import { render, staticRenderFns } from "./krathong.vue?vue&type=template&id=6cba2fcc&scoped=true"
import script from "./krathong.vue?vue&type=script&lang=js"
export * from "./krathong.vue?vue&type=script&lang=js"
import style0 from "./krathong.vue?vue&type=style&index=0&id=6cba2fcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cba2fcc",
  null
  
)

export default component.exports